import type { AxiosInstance } from 'axios';
import { unwrap } from '@/shared/api/client';
import type { AuthUser, LoginResponse } from '@/shared/stores/types';

export function createAuthApi(client: AxiosInstance) {
  return {
    login: (username: string, password: string) =>
      unwrap<LoginResponse>(client.post('/auth/login', { username, password })),

    me: () => unwrap<AuthUser>(client.get('/auth/me')),

    logout: () => unwrap<null>(client.post('/auth/logout')),
  };
}
